<template>
  <div class="text-left">
    <v-row>
      <v-col>
        <PInputField
          label="Enter an email address that is already registered in the trust group you want to find"
          :value="email"
          @update-event="(val) => (email = val)"
        />
      </v-col>
    </v-row>
    <v-row>
      <PSecondaryButton
        class="ml-3 mb-6"
        @click="emit('secondaryButtonClicked')"
        >{{ secondaryButtonText }}</PSecondaryButton
      >
      <v-spacer></v-spacer>
      <PPrimaryButton class="mr-3 mb-6" @click="findTrustGroup"
        >Find Trust Group</PPrimaryButton
      >
    </v-row>
  </div>
</template>

<script setup lang="ts">
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import PSecondaryButton from "@/components/custom/buttons/PSecondaryButton.vue";
import { ref, type Ref } from "vue";
import { genericError } from "@/modules/utilities";
import PInputField from "@/components/custom/PInputField.vue";
import { getTrustGroup } from "@/services/trustGroupAdminService";
import { TrustGroup } from "@/models/trustGroup";
import { useSnackBarStore } from "@/stores/snackBarStore";

const snackbarStore = useSnackBarStore();

const email = ref("");
const trustGroup: Ref<TrustGroup | undefined> = ref(new TrustGroup());
const showTrustGroupSearch = ref(true);

const props = defineProps<{
  secondaryButtonText: string;
}>();

const emit = defineEmits<{
  (e: "foundTrustGroup", trustGroup: TrustGroup | undefined): void;
  (e: "secondaryButtonClicked"): void;
}>();

async function findTrustGroup() {
  if (email.value == "") {
    return;
  }

  try {
    trustGroup.value = await getTrustGroup(email.value);
    showTrustGroupSearch.value = false;
    if (trustGroup.value == undefined) {
      snackbarStore.showError("Trust group not found");
    } else {
      emit("foundTrustGroup", trustGroup.value);
    }
  } catch (error) {
    snackbarStore.showError(genericError);
    showTrustGroupSearch.value = true;
  }
}
</script>
